
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index_46clientrQO1L4y5kOr7zxd96nm_orvJFkkiU0mtTja9VlNHc10Meta } from "/app/app/pages/auth/index.client.vue?macro=true";

let _createClientPage
async function createClientPage(loader) {
  _createClientPage ||= await import("/app/node_modules/.pnpm/nuxt@4.1.2_@parcel+watcher@2.5.1_@types+node@24.9.1_@vue+compiler-sfc@3.5.22_better-sql_cdcf5fe8d142b756aebade0869f3012a/node_modules/nuxt/dist/components/runtime/client-component.js").then(r => r.createClientPage)
  return _createClientPage(loader);
}
import { default as change_45password_46clienti2wIStt01rtMTMovqc1QVz9NjRtAnK5ryzGd8Bz7lIQMeta } from "/app/app/pages/auth/change-password.client.vue?macro=true";
import { default as authj4ucqEr04LcC6ccwO_8ZSP5jzanm3QfYgf_0g97wTKoMeta } from "/app/app/pages/auth.vue?macro=true";
import { default as indexolZbIEOs9UjQXoEMrm7nKSFbh6AheHkw9pJFhprWxGgMeta } from "/app/app/pages/index/index.vue?macro=true";
import { default as faqAsSnTDiuZZPGGFAg1cMuQ_ZPDjssiXmL3W1XPFYsp3YMeta } from "/app/app/pages/index/(landing)/faq.vue?macro=true";
import { default as _91slug_93YZZEZM3eKJ4DqbcvAL_8lLrtGfjq_vxinK0J9fjPtvQMeta } from "/app/app/pages/index/article/[slug].vue?macro=true";
import { default as _91slug_93zfl0A8Ccp1IZCjVgOvpdlq2_0CqSNPjVem2cn5xRt2wMeta } from "/app/app/pages/index/product/[slug].vue?macro=true";
import { default as profile_46clientVpgui0pKVQ9hFJE7d9VbUQjQSkW4rTLoNBhGxQjxVPwMeta } from "/app/app/pages/index/profile.client.vue?macro=true";
import { default as aboutC7hetFxPCyxn_kw7efNlYNB79nGBxA2R7ZUcyJVDuLwMeta } from "/app/app/pages/index/(landing)/about.vue?macro=true";
import { default as legalcp5j178Dzuk4_at_RAIvtKLT_hd_OghO2X4MrtEqUoQMeta } from "/app/app/pages/index/(landing)/legal.vue?macro=true";
import { default as policyPMB_94REUHGSC06u9_dOz9NoNOfKkk3OjVKW1ZcozIIMeta } from "/app/app/pages/index/(landing)/policy.vue?macro=true";
import { default as chatbotGbgpfE4iHIqfP02hrS1VPACNkQD7ifCy1Maz7ipXArIMeta } from "/app/app/pages/index/(landing)/chatbot.vue?macro=true";
import { default as reshapeyuJfr91RSwWB4fQ3oqZKZYPp5AGJTskD5zUT7R6KeVwMeta } from "/app/app/pages/index/(landing)/reshape.vue?macro=true";
import { default as _91_91category_93_93eiCZAPj1a6zfXIoRR_rMqzeh8w0C1szbjYB01p320RkMeta } from "/app/app/pages/index/blog/[[category]].vue?macro=true";
import { default as contactsVGMyvDbxhZ8_SV4ShR1M7hK_caT5OW198b3qc3B2YqQMeta } from "/app/app/pages/index/(landing)/contacts.vue?macro=true";
import { default as personalaCvq1kh_zIo2xFl_ACt6i8O65vz3PGB8aatbp6rKTaAMeta } from "/app/app/pages/index/(landing)/personal.vue?macro=true";
import { default as index_46clientCZ4mWlnH3aiMGBzB30vf4w0tUV2fhqapmnKpXuoeY0cMeta } from "/app/app/pages/index/order/index.client.vue?macro=true";
import { default as bot_45legalmkzwzHQTk39lxSUzJUKrnviyAILDwBSIF_FRYOsII4AMeta } from "/app/app/pages/index/(landing)/bot-legal.vue?macro=true";
import { default as sustainableRTgKqa27gFpmytiEWTt_oF3tJwxa_SnbGpd8Muv9O_oMeta } from "/app/app/pages/index/(landing)/sustainable.vue?macro=true";
import { default as waste_guide_rLOGDShBfpHBjA7N28UUSuoyA_vPG2XmDUUj3v0E1UMeta } from "/app/app/pages/index/(landing)/waste_guide.vue?macro=true";
import { default as change_45refilN1ICIdTdkSWtt9KvjLknWNMsoPiJRrw1I6n7sXxX4o4Meta } from "/app/app/pages/index/(landing)/change-refil.vue?macro=true";
import { default as public_45offer0KWH9ez3vdV07S_A5ROx2G7HKqbIVAzvWzXtmEgWZlIMeta } from "/app/app/pages/index/(landing)/public-offer.vue?macro=true";
import { default as _91_46_46_46categories_93owo1Ewo0MVsmlBk5K942qJZllYu71Sa4yOqnumKtfa4Meta } from "/app/app/pages/index/catalog/[...categories].vue?macro=true";
import { default as successful_46clienteAQeufx186djK4Vgs05bjJFDIvTXBJ1SpmCgOb_d7T4Meta } from "/app/app/pages/index/order/successful.client.vue?macro=true";
import { default as hydration_guideblKv8t3SqV2v5xxjYJabEtpIakCdycZNMewd4tQZ_ewMeta } from "/app/app/pages/index/(landing)/hydration_guide.vue?macro=true";
import { default as change_45deodorantmEHyS7X8YbiDFREyxKgJ0dfLXuov1rg3Y60jnjRs08AMeta } from "/app/app/pages/index/(landing)/change-deodorant.vue?macro=true";
import { default as subscribe_45productiP3nD2qzgOIQC_NOw3D4a2RgTztHQflpN8VN0iTWV80Meta } from "/app/app/pages/index/(landing)/subscribe-product.vue?macro=true";
import { default as delivery_45and_45paymentj_xDgfP7LSMwhNzFi2aeeoT0NKMKG94MeWwHQ3GsW_YMeta } from "/app/app/pages/index/(landing)/delivery-and-payment.vue?macro=true";
import { default as social_45responsibilityoj0AyRjvMWqZT69ceN6eanojLHkiOl8f_FF3m_r2iAEMeta } from "/app/app/pages/index/(landing)/social-responsibility.vue?macro=true";
import { default as retinoid_calendar_dtmsT_1OQW2aZ8g9jTfW9sn0xNXY0Lur0_kf70FDpLRLJS8Meta } from "/app/app/pages/index/(landing)/retinoid_calendar_dtms.vue?macro=true";
import { default as guide_po_retinoidam_ot_dtmsRUseV_8BE_USd2PlS1uWpOZEaPVpVLs9rAP1Z3ZYRlAMeta } from "/app/app/pages/index/(landing)/guide_po_retinoidam_ot_dtms.vue?macro=true";
import { default as index4nVS2Dd4a5t9zrU2j8coCxsqtPYupm_GEv_2EzeGhJUMeta } from "/app/app/pages/index.vue?macro=true";
import { default as subscribelhGVL5c76RGq61wiXs9ZJEpLdvt11ZpXp1fgn8E_48cMeta } from "/app/app/pages/subscribe.vue?macro=true";
export default [
  {
    name: authj4ucqEr04LcC6ccwO_8ZSP5jzanm3QfYgf_0g97wTKoMeta?.name,
    path: "/auth",
    component: () => import("/app/app/pages/auth.vue"),
    children: [
  {
    name: "auth",
    path: "",
    component: () => createClientPage(() => import("/app/app/pages/auth/index.client.vue"))
  },
  {
    name: "auth-change-password",
    path: "change-password",
    component: () => createClientPage(() => import("/app/app/pages/auth/change-password.client.vue"))
  }
]
  },
  {
    name: index4nVS2Dd4a5t9zrU2j8coCxsqtPYupm_GEv_2EzeGhJUMeta?.name,
    path: "/",
    component: () => import("/app/app/pages/index.vue"),
    children: [
  {
    name: "index",
    path: "",
    component: () => import("/app/app/pages/index/index.vue")
  },
  {
    name: "index-faq",
    path: "faq",
    component: () => import("/app/app/pages/index/(landing)/faq.vue")
  },
  {
    name: "index-article-slug",
    path: "article/:slug()",
    component: () => import("/app/app/pages/index/article/[slug].vue")
  },
  {
    name: "index-product-slug",
    path: "product/:slug()",
    component: () => import("/app/app/pages/index/product/[slug].vue")
  },
  {
    name: "index-profile",
    path: "profile",
    meta: {"middleware":["authentication"]},
    component: () => createClientPage(() => import("/app/app/pages/index/profile.client.vue"))
  },
  {
    name: "index-about",
    path: "about",
    component: () => import("/app/app/pages/index/(landing)/about.vue")
  },
  {
    name: "index-legal",
    path: "legal",
    component: () => import("/app/app/pages/index/(landing)/legal.vue")
  },
  {
    name: "index-policy",
    path: "policy",
    component: () => import("/app/app/pages/index/(landing)/policy.vue")
  },
  {
    name: "index-chatbot",
    path: "chatbot",
    component: () => import("/app/app/pages/index/(landing)/chatbot.vue")
  },
  {
    name: "index-reshape",
    path: "reshape",
    component: () => import("/app/app/pages/index/(landing)/reshape.vue")
  },
  {
    name: "index-blog-category",
    path: "blog/:category?",
    meta: _91_91category_93_93eiCZAPj1a6zfXIoRR_rMqzeh8w0C1szbjYB01p320RkMeta || {},
    component: () => import("/app/app/pages/index/blog/[[category]].vue")
  },
  {
    name: "index-contacts",
    path: "contacts",
    component: () => import("/app/app/pages/index/(landing)/contacts.vue")
  },
  {
    name: "index-personal",
    path: "personal",
    component: () => import("/app/app/pages/index/(landing)/personal.vue")
  },
  {
    name: "index-order",
    path: "order",
    meta: index_46clientCZ4mWlnH3aiMGBzB30vf4w0tUV2fhqapmnKpXuoeY0cMeta || {},
    component: () => createClientPage(() => import("/app/app/pages/index/order/index.client.vue"))
  },
  {
    name: "index-bot-legal",
    path: "bot-legal",
    component: () => import("/app/app/pages/index/(landing)/bot-legal.vue")
  },
  {
    name: "index-sustainable",
    path: "sustainable",
    component: () => import("/app/app/pages/index/(landing)/sustainable.vue")
  },
  {
    name: "index-waste_guide",
    path: "waste_guide",
    component: () => import("/app/app/pages/index/(landing)/waste_guide.vue")
  },
  {
    name: "index-change-refil",
    path: "change-refil",
    component: () => import("/app/app/pages/index/(landing)/change-refil.vue")
  },
  {
    name: "index-public-offer",
    path: "public-offer",
    component: () => import("/app/app/pages/index/(landing)/public-offer.vue")
  },
  {
    name: "index-catalog-categories",
    path: "catalog/:categories(.*)*",
    meta: _91_46_46_46categories_93owo1Ewo0MVsmlBk5K942qJZllYu71Sa4yOqnumKtfa4Meta || {},
    component: () => import("/app/app/pages/index/catalog/[...categories].vue")
  },
  {
    name: "index-order-successful",
    path: "order/successful",
    component: () => createClientPage(() => import("/app/app/pages/index/order/successful.client.vue"))
  },
  {
    name: "index-hydration_guide",
    path: "hydration_guide",
    component: () => import("/app/app/pages/index/(landing)/hydration_guide.vue")
  },
  {
    name: "index-change-deodorant",
    path: "change-deodorant",
    component: () => import("/app/app/pages/index/(landing)/change-deodorant.vue")
  },
  {
    name: "index-subscribe-product",
    path: "subscribe-product",
    component: () => import("/app/app/pages/index/(landing)/subscribe-product.vue")
  },
  {
    name: "index-delivery-and-payment",
    path: "delivery-and-payment",
    component: () => import("/app/app/pages/index/(landing)/delivery-and-payment.vue")
  },
  {
    name: "index-social-responsibility",
    path: "social-responsibility",
    component: () => import("/app/app/pages/index/(landing)/social-responsibility.vue")
  },
  {
    name: "index-retinoid_calendar_dtms",
    path: "retinoid_calendar_dtms",
    component: () => import("/app/app/pages/index/(landing)/retinoid_calendar_dtms.vue")
  },
  {
    name: "index-guide_po_retinoidam_ot_dtms",
    path: "guide_po_retinoidam_ot_dtms",
    component: () => import("/app/app/pages/index/(landing)/guide_po_retinoidam_ot_dtms.vue")
  }
]
  },
  {
    name: "subscribe",
    path: "/subscribe",
    component: () => import("/app/app/pages/subscribe.vue")
  }
]